// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2UmjW";
var _4 = "icon-3lAIM";
var _5 = "wrapper-1C_kK";
var _6 = "header-2u_FI";
var _7 = "title-36AwF";
var _8 = "count-1soHJ";
var _9 = "lastMessage-2JkIY";
var _a = "lastMessage__title_wrapper-1YJxg";
var _b = "lastMessage__title-FFDcM";
var _c = "lastMessage__date-20RH_";
var _d = "lastMessage__text-2uQQr";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "icon", _5 as "wrapper", _6 as "header", _7 as "title", _8 as "count", _9 as "lastMessage", _a as "lastMessage__title_wrapper", _b as "lastMessage__title", _c as "lastMessage__date", _d as "lastMessage__text" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "icon": _4, "wrapper": _5, "header": _6, "title": _7, "count": _8, "lastMessage": _9, "lastMessage__title_wrapper": _a, "lastMessage__title": _b, "lastMessage__date": _c, "lastMessage__text": _d }
